'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/usermanual", "/usermanual/list");
  $stateProvider
    .state('usermanual', {
      url: '/usermanual',
      template: require('./usermanual.html'),
      authenticate: true
    })
    .state('usermanual.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'UsermanualListController',
      controllerAs: 'umListCtrl'
    })
    .state('usermanual.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'UsermanualAddController',
      controllerAs: 'umAddCtrl'
    })
    .state('usermanual.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'UsermanualEditController',
      controllerAs: 'umEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/usermanual/usermanual.routes.js